var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonicIosCheckmarkCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.541,
    height: 46.541,
    viewBox: "0 0 46.541 46.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M26.646,3.375A23.271,23.271,0,1,0,49.916,26.646,23.267,23.267,0,0,0,26.646,3.375ZM38.56,20.213,23.6,35.238h-.011a2.02,2.02,0,0,1-1.3.615,1.959,1.959,0,0,1-1.309-.638L14.719,28.95a.446.446,0,0,1,0-.638l1.991-1.991a.433.433,0,0,1,.627,0L22.3,31.288l13.649-13.75a.442.442,0,0,1,.313-.134h0a.406.406,0,0,1,.313.134l1.958,2.025A.441.441,0,0,1,38.56,20.213Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#4baf4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosCheckmarkCircle);
export default __webpack_public_path__ + "static/media/ionic-ios-checkmark-circle.e12f4e722a67cf2f50f37b5b8ea55466.svg";
export { ForwardRef as ReactComponent };